import {
	ReminderSortFieldEnum,
	ReminderStatusEnum,
	SortDirectionEnum,
} from "web_myplann/Infrastructure/Api/Api";

// All reminder statuses except Solved — Solved reminders are excluded from the
// visible list (see selectReminders.ts for why the same filter is also kept client-side).
export const VISIBLE_REMINDER_STATUSES = [
	ReminderStatusEnum.Active,
	ReminderStatusEnum.Soon,
	ReminderStatusEnum.Overdue,
	ReminderStatusEnum.Snoozed,
];

export const REMINDER_SORT_BY = ReminderSortFieldEnum.Date;
export const REMINDER_SORT_DIRECTION = SortDirectionEnum.Asc;
